<template>
  <div class="bot-detail-left-center">
    <ul>
      <li
        v-for="(item, index) in botList"
        :key="item.id"
        :class="{ show: curtId == index }"
        @click="upStatus(index)"
        style="cursor: pointer"
      >
        {{ item.title }}
      </li>
    </ul>
    <div class="child-bot">
      <a-spin :spinning="recordlistSpinning">
        <no-data v-if="recordlist && recordlist.length === 0"></no-data>
        <div class="row" v-else v-for="(item, index) in recordlist" :key="index">
          <div class="col-one">
            <div class="state">{{ item.recordType | filternumtoname }}</div>
          </div>
          <div class="col-two">
            <p>{{ item.createByName }}</p>
            <p v-if="item.recordType == 4" class="flex-warp">
              <!-- @click="goTouristSourceDetails(item.requirementId)"禁止跳转客源
                style="color: var(--ThemeColor); cursor: pointer" -->
              带<span
              >{{ item.takeLookNames }}</span
              >查看了该房源,带看反馈:{{ item.recordContent }}
            </p>
            <p v-else class="flex-warp">{{ item.recordContent }}</p>
          </div>
          <div class="col-three">
            <p style="text-align: right">{{ item.createTime }}</p>
            <template v-if="item.accessoryFileList">
              <p v-if="item.recordType == 1" class="time downLoad" @click="handledownload(item.accessoryFileList)">
                下载附件
              </p>
            </template>
          </div>
        </div>
        <div v-if="recordlist && recordlist.length !== 0" style="margin-top: 15px; float: right">
          <!--分页-->
          <a-pagination :current="current" :total="recordpage.total" @change="onChange" />
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      botList: [
        { id: 1, title: '全部', status: true },
        { id: 2, title: '跟进', status: false },
        { id: 3, title: '面访', status: false },
        { id: 4, title: '钥匙', status: false },
        { id: 5, title: '查看', status: false },
        { id: 6, title: '其他', status: false },
        { id: 7, title: '被带看', status: false },
        { id: 8, title: '意向', status: false }
      ]
    }
  },
  props: {
    recordlistSpinning: {
      type: Boolean,
      default: false
    },
    recordlist: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 1
    },
    recordpage: {
      type: Object,
      default: () => {}
    },
    curtId: {
      type: Number | String,
      default: 0
    }
  },
  filters: {
    filternumtoname (val_) {
      const val = parseInt(val_)
      if (val === 1) {
        return '面访'
      }
      if (val === 2) {
        return '跟进'
      }
      if (val === 3) {
        return '查看'
      }
      if (val === 4) {
        return '被带看'
      }
      if (val === 5) {
        return '钥匙'
      }
      if (val === 6) {
        return '其他'
      }
      if (val === 8) {
        return '意向'
      }
    }
  },
  methods: {
    // 下载附件
    handledownload (list) {
      const url = list[0].url
      var a = document.createElement('a') // 创建一个a节点插入的document
      var event = new MouseEvent('click') // 模拟鼠标click点击事件
      a.download = 'file' // 设置a节点的download属性值
      a.href = url // 将图片的src赋值给a节点的href
      a.dispatchEvent(event)
    },
    upStatus (index) {
      this.$emit('upStatus', index)
    },
    onChange (current) {
      this.$emit('onChange', current)
    },
    // 前往客源详情
    goTouristSourceDetails (id) {
      this.$router.push({
        path: '/tourist/details',
        query: { id }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.downLoad {
  cursor: pointer;
  text-align: right;
  color: var(--ThemeColor);
}
.state {
  width: 50px;
  height: 50px;
  background: #ccc;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 50px;
  // margin-top: 15px;
  margin-top: 0px;
}

.bot-detail-left-center {
  width: 91%;
  padding-top: 30px;
  & > ul {
    // width: 80%;
    list-style: none;
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    // justify-content: space-around;
    align-items: center;
    // margin-left: 49px;
    padding-left: 0px;
    .show {
      width: 70px;
      height: 30px;
      background-color: var(--ThemeColor);
      border-radius: 30px;
      line-height: 30px;
      margin-right: 25px;
      text-align: center;
      color: white;
    }
    & > li {
      width: 70px;
      height: 30px;
      background-color: #cccccc;
      border-radius: 30px;
      line-height: 30px;
      margin-right: 25px;
      text-align: center;
      color: white;
    }
  }
  .child-bot {
    margin-top: 20px;
    .row {
      padding-bottom: 10px;
      padding-top: 10px;
      border-bottom: 1px solid #f2f6fc;
      display: flex;
      align-items: center;
      .col-one {
        margin-right: 10px;
      }
      .col-two {
        flex: 1;
        line-height: 30px;
        .flex-warp {
          word-break: break-all;
        }
        p{
          margin-bottom:0px;
        }
      }
      .col-three {
        width: 140px;
        align-self: flex-start;
      }
    }
  }
}
</style>
